import { ReasonsForAbsence } from '@/shared/constants/booking/ReasonsForAbsence'

export default function(
  payload,
  selectedDay,
  isNextMonday,
  firstAccessibleLocation
) {
  return {
    selectedDay,
    isNextMonday,
    reasonForAbsence: payload?.reasonForAbsence
      ? payload?.reasonForAbsence
      : ReasonsForAbsence[0].id, // Default: Not Provided
    room: payload?.room ? payload?.room : '',
    additionalNotes: payload?.additionalNotes ? payload?.additionalNotes : '',
    locationId: firstAccessibleLocation?.locationId,
    classification: payload?.classification ? payload?.classification : null,
    subjectList: payload?.subjectList ? payload?.subjectList : [],
  }
}
